import React from 'react';
import { connect } from "react-redux";
import './../main.scss'
import './../../main.css'
import { withNamespaces } from 'react-i18next';
import { Row } from 'react-bootstrap';

export class Total extends React.Component{

   
    render(){  
        const { t } = this.props
        return(    
            <Row className="total_users">
                <span className="mb-2">{t('Total')}</span>
                <div className="recharts-surface p-4" id="tabs">
                    <p>{t('Total amount')} : {this.props.numberOfTransactions}</p>
                </div>
            </Row>
        )
    }  
}

const mapStateToProps = state => {
    return {
        numberOfTransactions: state.dashboard.numberOfTransactions?.[0]?.amountWithPdv,
        amount: state.dashboard.amountTotal
    };
};
  
const mapDispatchToProps = dispatch => {
    return {
      mapState: (type, data) => dispatch({ type: type, data: data}),
      API: (type, data) => dispatch({ type: type, data: data})
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withNamespaces()(Total));
